import { declareWebpackPublicPath } from '@commercial-web-client-config/runtime-config-vue-app';
import type { CommercialWebPublicApp } from '@/types';
declareWebpackPublicPath();

// Provide a global interface to notify when the public app instance is created,
// due to the dynamic import below creating an unknown wait time.
let isAppReady = false;
let isAppImportError = false;
let readyCallbacks: Array<{
    resolve: (app: CommercialWebPublicApp) => void;
    reject: (error: unknown) => void;
}> = [];
function useCommercialWebPublicApp(): Promise<CommercialWebPublicApp> {
    if (isAppReady) {
        return Promise.resolve(window.commercialWebPublicApp);
    } else if (isAppImportError) {
        return Promise.reject(new Error('App failed to load.'));
    } else {
        return new Promise<CommercialWebPublicApp>((resolve, reject) => {
            readyCallbacks.push({ resolve, reject });
        });
    }
}
window.useCommercialWebPublicApp = useCommercialWebPublicApp;

// Use a dynamic import to allow webpack to interface with module federation code.
import('./initialize-app').then(() => {
    isAppReady = true;
    for (const callbacks of readyCallbacks) {
        try {
            callbacks.resolve(window.commercialWebPublicApp);
        } catch (error) {
            // Ignore.
        }
    }
    readyCallbacks = [];
}).catch((error) => {
    isAppImportError = true;
    for (const callbacks of readyCallbacks) {
        try {
            callbacks.reject(error);
        } catch (error) {
            // Ignore.
        }
    }
    readyCallbacks = [];
});
